(function($, Drupal) {
  Drupal.behaviors.faq_anchors = {
    attach: function(context, settings) {
      $('.faq-accordion-wrapper h2').once('create-faq-anchors').each(function() {
        let anchor_id = $(this).text().replace(/\s+/g, '-').toLowerCase();
        $(this).attr('id', anchor_id);
        $('#faq-anchors').append('<li><a href="#' + anchor_id + '"/>' + $(this).text() + '</a></li>');
      });
    }
  };
})(jQuery, Drupal);
